import React from "react";
import { Card, CardTitle } from "../ui/Card";
import Field from "../ui/Field";
import { CheckboxCardGrid } from "../ui/CheckboxCard";
import { FAULT_OPTIONS } from "../options";
import PreQualificationSection from "./PreQualificationSection";

export default function FaultSection({ form, onRecordingAdded }) {
  const { values, setField } = form;

  return (
    <Card radius="panel">
      <CardTitle>Fault description</CardTitle>

      <Field label="Fault type" className="rma-nc-mb-22">
        <CheckboxCardGrid
          options={FAULT_OPTIONS}
          value={values.faults}
          onChange={(faults) => setField("faults", faults)}
        />
      </Field>

      <PreQualificationSection form={form} onRecordingAdded={onRecordingAdded} />
    </Card>
  );
}
